import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa"; // Importing icons
import "../assets/style.css";

const FormTwo = () => {
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 box-margin height-card">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h5>Customer List</h5>
                <button className="btn btn-primary" style={{ backgroundColor: '#072848', color: 'white' }}>Button</button>
              </div>
            </div>
          </div>

          {/* Form Section */}
          <div className="col-xl-12 mb-4">
            <div className="card">
              {/* <div className="card-header">
                <h5>Add New Customer</h5>
              </div> */}
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-3">
                      <input type="text" className="form-control" placeholder="First Name" required />
                    </div>
                    <div className="col-md-3">
                      <input type="text" className="form-control" placeholder="Last Name" required />
                    </div>
                    <div className="col-md-3">
                      <input type="email" className="form-control" placeholder="Email" required />
                    </div>
                    <div className="col-md-3">
                      <input type="text" className="form-control" placeholder="Phone" required />
                    </div>
                  </div>
                  <div className="mt-3">
                    <button className="btn btn-success">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>

        
          
        </div>
      </div>
    </>
  );
};

export default FormTwo;
